export const INVESTOR_CAPABILITY_KEY = 'investor_access_capability';

export const takeInvestorShareToken = (locationLike, replaceState) => {
  const search = typeof locationLike?.search === 'string' ? locationLike.search : '';
  const pathname = typeof locationLike?.pathname === 'string' && locationLike.pathname.startsWith('/')
    ? locationLike.pathname
    : '/investors';
  const token = new URLSearchParams(search).get('token');

  if (token) replaceState(null, '', pathname);
  return token;
};

export const exchangeInvestorShareToken = async ({ apiUrl, token, fetchImpl = fetch }) => {
  const response = await fetchImpl(`${apiUrl}/api/investors/access`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  if (!response.ok) return null;

  const data = await response.json();
  return typeof data?.capability === 'string' && data.capability.length > 0
    ? data.capability
    : null;
};

export const readInvestorCapability = () => {
  try {
    return sessionStorage.getItem(INVESTOR_CAPABILITY_KEY);
  } catch {
    return null;
  }
};

export const storeInvestorCapability = (capability) => {
  try {
    sessionStorage.setItem(INVESTOR_CAPABILITY_KEY, capability);
    return sessionStorage.getItem(INVESTOR_CAPABILITY_KEY) === capability;
  } catch {
    return false;
  }
};

export const verifyInvestorCapability = async ({ apiUrl, capability, fetchImpl = fetch }) => {
  if (!capability) return false;
  const response = await fetchImpl(`${apiUrl}/api/investors/metrics`, {
    headers: { 'X-Investor-Capability': capability },
  });
  if (!response.ok) return false;
  const data = await response.json();
  return data?.verified === true;
};
